import http from '@/communication/AuthConnection'

export default async ({ state, commit }) => {
  const boardId = state.filters.selectedBoard
  const params = { ...state.filters }

  if (!params.suspendedNoDate) delete params.suspendedNoDate
  if (!params.suspendedWithDate) delete params.suspendedWithDate
  if (!params.reproved) delete params.reproved
  if (!params.canceled) delete params.canceled

  const loadSheet = await http.get(`/v1/board/${boardId}/sheet`, { params })
    .then(pData => pData.data)

  commit('STAGES', loadSheet.stages.stages)
  commit('ROWS', loadSheet.rows)
  commit('BOARD_NAME', loadSheet.stages.name)
  commit('EVENTS', loadSheet.events)
}



// WEBPACK FOOTER //
// ./src/brain/board/board-sheet/index.js